module.exports = __webpack_public_path__ + "img/rickenbach-logo.59c78dda.jpg";